<script setup lang="ts">
interface FormProps {
  busy?: boolean
  disabled?: boolean
  gap?: "sm" | "md" | "lg"
}
defineOptions({
  inheritAttrs: false,
})

const props = withDefaults(defineProps<FormProps>(), {
  busy: false,
  disabled: false,
  gap: "md",
})

const emit = defineEmits<{
  submit: [event: SubmitEvent]
}>()

const gapClasses = {
  sm: "gap-4",
  md: "gap-6",
  lg: "gap-8",
}

const actionGapClasses = {
  sm: "gap-2 pt-1",
  md: "gap-3 pt-2",
  lg: "gap-4 pt-3",
}

function onSubmit(event: SubmitEvent) {
  if (props.busy || props.disabled) {
    event.preventDefault()
    event.stopPropagation()
    return
  }

  emit("submit", event)
}
</script>

<template>
  <form
    v-bind="$attrs"
    novalidate
    class="flex flex-col"
    :class="gapClasses[props.gap]"
    :aria-busy="busy || undefined"
    :aria-disabled="disabled || undefined"
    :data-busy="busy || undefined"
    :data-disabled="disabled || undefined"
    @submit="onSubmit"
  >
    <slot name="error" />

    <fieldset class="contents m-0 min-w-0 border-0 p-0" :disabled="busy || disabled">
      <div class="flex flex-col" :class="gapClasses[props.gap]">
        <slot />
      </div>
      <div v-if="$slots.actions" class="flex flex-col" :class="actionGapClasses[props.gap]">
        <slot name="actions" />
      </div>
    </fieldset>
  </form>
</template>
